import { Box, Grid, Stack, Typography } from "@mui/material";
import { Card } from "../../ui/Card";
import Title from "../../ui/Title";
import { Link } from "react-router-dom";
import styled from "styled-components";

import {
  HomeIcon,
  CompanyIcon,
  RupeeIcon,
  FileCopyIcon,
  DescriptionIcon,
  ManageAccountsIcon
} from "../../../common/iconsData";

interface AllSetting {
  title: string;
  path: string;
}

interface SettingsType {
  title: string;
  settings: AllSetting[];
  icon: JSX.Element;
}

const settingsTab: SettingsType[] = [
  {
    title: "Company",
    icon: <CompanyIcon color="secondary" />,
    settings: [
      {
        title: "Company Profile",
        path: "company-profile",
      },
      {
        title: "KYC",
        path: "kyc",
      },
      {
        title: "Change Password",
        path: "change-password",
      },
    ],
  },

  {
    title: "Pickup Address",
    icon: <HomeIcon color="secondary" />,
    settings: [
      {
        title: "Manage Pickup Addresses",
        path: "manage-pickup-addresses",
      },
    ],
  },

  // {
  //   title: "COD Payments",
  //   icon: <RupeeIcon color="secondary" />,
  //   settings: [
  //     {
  //       title: "Bank Details",
  //       path: "bank-details",
  //     },
  //     {
  //       title: "Early COD",
  //       path: "early-cod",
  //     },
  //     {
  //       title: "Postpaid",
  //       path: "postpaid",
  //     },
  //   ],
  // },

  {
    title: "Billing",
    icon: <DescriptionIcon color="secondary" />,
    settings: [
      {
        title: "GSTIN Invoicing",
        path: "gstin_invoicing",
      },
      {
        title: "Biling Invoicing",
        path: "billing_invoicing",
      },
    ],
  },

  {
    title: "User Role Management",
    icon: <ManageAccountsIcon color="secondary" />,
    settings: [
      {
        title: "Manage Users",
        path: "user-role-management",
      },
    ],
  },

  // {
  //   title: "Return",
  //   icon: <FileCopyIcon color="secondary" />,
  //   settings: [
  //     {
  //       title: "Return Settings",
  //       path: "returns?page=0&label=return",
  //     },
  //     {
  //       title: "Refund Settings",
  //       path: "returns?page=1&label=refund",
  //     },
  //   ],
  // },
];

const SettingsBorder = styled.div`
  padding: 20px;
  border: 1px solid #909090;
  border-radius: 6px;
  height: 100%;
`;

const Settings = () => {
  return (
    <>
      <Title title="Settings" />
      <Card>
        <Grid container spacing={2}>
          {settingsTab.map((el, index) => (
            <Grid key={index} item md={3} sm={6} xs={12}>
              <SettingsBorder>
                <Stack
                  direction={"row"}
                  justifyContent={"flex-start"}
                  columnGap={"10px"}
                >
                  {el.icon}
                  <Typography marginBottom={3} fontSize={18}>
                    {el.title}
                  </Typography>
                </Stack>

                {el.settings.map((insideEl, insideKey) => (
                  <Box
                    sx={{
                      marginLeft: "33px",
                    }}
                    key={insideKey}
                  >
                    <Link
                      style={{
                        color: "#3ba4d4",
                      }}
                      to={`/settings/${insideEl.path}`}
                    >
                      <Typography marginBottom={1} fontSize={14}>
                        {`${insideEl.title} >`}
                      </Typography>
                    </Link>
                  </Box>
                ))}
              </SettingsBorder>
            </Grid>
          ))}
        </Grid>
      </Card>
    </>
  );
};

export default Settings;
